import React from 'react';
import { SOCIAL_PLATFORMS, openSharePopup } from '../../../constants/socialShare';

interface SocialShareButtonsProps {
  shareUrl: string;
  title: string;
  size?: 'sm' | 'md';
}

export const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({
  shareUrl,
  title,
  size = 'md'
}) => {
  const handleShare = (platformId: string) => {
    const platform = SOCIAL_PLATFORMS.find(p => p.id === platformId);
    if (platform) {
      openSharePopup(platform.getShareUrl(shareUrl, title));
    }
  };

  const btnSize = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
  const iconSize = size === 'sm' ? 13 : 18;

  return (
    <div className={`flex ${size === 'sm' ? 'gap-1' : 'gap-2.5'}`}>
      {SOCIAL_PLATFORMS.map((platform) => (
        <button
          type="button"
          key={platform.id}
          onClick={() => handleShare(platform.id)}
          className={`${size === 'md' ? 'flex-1' : ''} flex items-center justify-center ${btnSize} bg-neutral-100 rounded-lg hover:bg-neutral-200 transition-colors`}
          title={`Share on ${platform.name}`}
          aria-label={`Share on ${platform.name}`}
        >
          <svg width={iconSize} height={iconSize} viewBox={platform.icon.viewBox} fill="#6B7280">
            <path d={platform.icon.path} />
          </svg>
        </button>
      ))}
    </div>
  );
};
